<div class="grid" [ngClass]="{'no-content': noContent}">
    @for (time of gridWithBadges(); track $index; let first = $first) {
        <div [ngStyle]="{'flex-grow': time.durationToNext}"
             [ngClass]="{'first': first}"
             class="grid-line">
            <dv-timeline-badges [badges]="time.infoBadges"/>
        </div>
    }
</div>
